import React from 'react';
import styles from './NavbarLogo.module.css';

const NavbarLogo = () => {
    return (
        <div className={styles.navbarLogo}>
            <a
                href="/"
                className={styles.logoLink}
            >
                <div className={styles.logoContainer}>
                    <img
                        src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-2.svg"
                        alt="Howzit Logo"
                        className={styles.logoImage}
                    />
                </div>
            </a>
        </div>
    );
};

export default NavbarLogo;